import { APICore } from './apiCore'

const api = new APICore()

function getItSendStats (params) {
  const baseUrl = '/infotools-send-stats'
  return api.get(baseUrl, params)
}

function getItSendStat (id) {
  const baseUrl = `/infotools-send-stats/${id}`
  return api.get(baseUrl, {})
}

function sendMail (params) {
  const baseUrl = '/infotools-send-stats/sendMail'
  return api.create(baseUrl, params)
}

function addItSendStat (params) {
  const baseUrl = '/infotools-send-stats'
  return api.create(baseUrl, params)
}

function updateItSendStat (params) {
  const baseUrl = '/infotools-send-stats'
  return api.update(baseUrl, params)
}

function deleteItSendStat (params) {
  const baseUrl = '/infotools-send-stats'
  return api.delete(baseUrl, params)
}

export { getItSendStats, getItSendStat, sendMail, addItSendStat, updateItSendStat, deleteItSendStat }
